import { render, staticRenderFns } from "./RegistroItem.vue?vue&type=template&id=fd4964ac"
import script from "./RegistroItem.vue?vue&type=script&lang=js"
export * from "./RegistroItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports